import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

export default function PublicSignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [gender, setGender] = useState('male');
  const [country, setCountry] = useState('EG');
  const [selectedMarkets, setSelectedMarkets] = useState([]);
  const [tradingStyle, setTradingStyle] = useState('intraday');
  const [source, setSource] = useState('social_media');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('register');

  const markets = [
    { id: 'EGX', name: 'Egyptian Exchange', flag: '🇪🇬' },
    { id: 'TADAWUL', name: 'Saudi Stock Exchange', flag: '🇸🇦' },
    { id: 'ADX', name: 'Abu Dhabi', flag: '🇦🇪' },
    { id: 'DFM', name: 'Dubai', flag: '🇦🇪' },
    { id: 'BKP', name: 'Kuwait', flag: '🇰🇼' },
    { id: 'QE', name: 'Qatar', flag: '🇶🇦' },
    { id: 'NASDAQ', name: 'US Market', flag: '🇺🇸' }
  ];

  const toggleMarket = (marketId) => {
    if (selectedMarkets.includes(marketId)) {
      setSelectedMarkets(selectedMarkets.filter(id => id !== marketId));
    } else {
      setSelectedMarkets([...selectedMarkets, marketId]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!phone.trim()) {
      alert('يجب إدخال رقم التليفون');
      setLoading(false);
      return;
    }

    try {
      // 1. إنشاء الحساب في Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. حفظ البيانات في Firestore
      await setDoc(doc(db, 'users', user.uid), {
        email: email,
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        gender: gender,
        country: country,
        subscribed_markets: selectedMarkets.length > 0 ? selectedMarkets : ['EGX'],
        trading_style: tradingStyle,
        source: source,
        role: "pending",
        trial_status: "pending",
        subscription: {
          start_date: null,
          end_date: null,
          status: "inactive",
          type: "trial"
        },
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      });

      // 3. ✅ خروج فوري من الجلسة بعد التسجيل
      await auth.signOut();

      // 4. عرض رسالة التفعيل
      setStep('pending');

    } catch (err) {
      console.error(err);
      if (err.code === 'auth/email-already-in-use') {
        alert('هذا البريد الإلكتروني مسجل مسبقًا. يرجى استخدام بريد مختلف أو تسجيل الدخول.');
      } else if (err.message.includes('phone')) {
        alert('رقم التليفون غير صالح. يرجى التأكد من صيغة الرقم.');
      } else {
        alert(err.message || 'حدث خطأ أثناء التسجيل. يرجى المحاولة مرة أخرى.');
      }
      setLoading(false);
    }
  };

  if (step === 'pending') {
    return (
      <div style={{ 
        maxWidth: '500px', 
        margin: '40px auto', 
        padding: '30px', 
        backgroundColor: 'white', 
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '60px', 
            height: '60px', 
            backgroundColor: '#3b82f6', 
            borderRadius: '50%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            margin: '0 auto 20px',
            color: 'white',
            fontSize: '24px'
          }}>
            ⏳
          </div>
          <h2 style={{ color: '#1e40af' }}>تم التسجيل بنجاح!</h2>
          <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
            سيتم التواصل معك خلال 24 ساعة على الرقم: <strong>{phone}</strong> لتفعيل حسابك التجريبي.
          </p>
          <p style={{ color: '#64748b', marginTop: '10px' }}>
            شكرًا لاهتمامك بـ TradeAH!
          </p>
          <div style={{ marginTop: '20px' }}>
            <a 
              href="/login"
              style={{
                backgroundColor: '#1e40af',
                color: 'white',
                textDecoration: 'none',
                padding: '10px 24px',
                borderRadius: '8px',
                fontWeight: 'bold',
                display: 'inline-block'
              }}
            >
              العودة لصفحة الدخول
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '20px auto', 
      padding: '30px', 
      backgroundColor: 'white', 
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    }}>
      <h2 style={{ textAlign: 'center', color: '#1e40af', marginBottom: '24px' }}>
        إنشاء حساب تجريبي
      </h2>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              الاسم الأول *
            </label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px'
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              الاسم الأخير *
            </label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px'
              }}
            />
          </div>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            رقم التليفون *
          </label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+201012345678"
            required
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          />
          <p style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
            سيتم التواصل معك على هذا الرقم لتفعيل الحساب
          </p>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            البريد الإلكتروني *
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            كلمة المرور * (6+ أحرف)
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            الجنس
          </label>
          <div style={{ display: 'flex', gap: '12px' }}>
            <label>
              <input
                type="radio"
                name="gender"
                value="male"
                checked={gender === 'male'}
                onChange={(e) => setGender(e.target.value)}
              /> ذكر
            </label>
            <label>
              <input
                type="radio"
                name="gender"
                value="female"
                checked={gender === 'female'}
                onChange={(e) => setGender(e.target.value)}
              /> أنثى
            </label>
          </div>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            الدولة
          </label>
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          >
            <option value="EG">مصر</option>
            <option value="SA">السعودية</option>
            <option value="AE">الإمارات</option>
            <option value="KW">الكويت</option>
            <option value="QA">قطر</option>
            <option value="US">الولايات المتحدة</option>
            <option value="OTHER">أخرى</option>
          </select>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '12px', fontWeight: '500' }}>
            الأسواق المهتم بها (اختر على الأقل واحد)
          </label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            {markets.map(market => (
              <label key={market.id} style={{ 
                padding: '8px', 
                border: selectedMarkets.includes(market.id) ? '1px solid #1e40af' : '1px solid #ddd',
                borderRadius: '6px',
                backgroundColor: selectedMarkets.includes(market.id) ? '#eff6ff' : 'white',
                cursor: 'pointer'
              }}>
                <input
                  type="checkbox"
                  checked={selectedMarkets.includes(market.id)}
                  onChange={() => toggleMarket(market.id)}
                  style={{ marginRight: '8px' }}
                />
                {market.flag} {market.name}
              </label>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            نوع التداول
          </label>
          <select
            value={tradingStyle}
            onChange={(e) => setTradingStyle(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          >
            <option value="intraday">إنتراداي</option>
            <option value="short">قصير المدى</option>
            <option value="medium">متوسط المدى</option>
          </select>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            كيف عرفت عنّا؟
          </label>
          <select
            value={source}
            onChange={(e) => setSource(e.target.value)}
            style={{
              width: '100%',
              padding: '10.6px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '16px'
            }}
          >
            <option value="social_media">وسائل التواصل الاجتماعي</option>
            <option value="friend">صديق/زميل</option>
            <option value="search_engine">محركات البحث</option>
            <option value="advertisement">إعلان</option>
            <option value="other">أخرى</option>
          </select>
        </div>

        <button
          type="submit"
          disabled={loading || selectedMarkets.length === 0}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: (loading || selectedMarkets.length === 0) ? '#94a3b8' : '#1e40af',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            cursor: (loading || selectedMarkets.length === 0) ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'جاري إنشاء الحساب...' : 'إنشاء حساب تجريبي'}
        </button>
      </form>
    </div>
  );
}